import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RegistrationData } from 'src/app/class/datatype';
import { environment } from 'src/environments/environment';

@Injectable()
export class NotificationService {
  constructor(private http: HttpClient) {}

  sendNotification(data: RegistrationData, reminder = false): Observable<any> {
    return this.http.post<any>(environment.apiUrl + 'clientapi/notification', {
      type: data.status,
      regcode: data.regcode,
      reminder: reminder,
    });
  }
}
